import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Нетронутое поле одной строкой: подпись слева, значение справа.
 *
 * Так набрано «остальное без изменений» в разборе анкеты. Полноразмерными
 * блоками эти одиннадцать полей занимали целый экран и спорили с теми тремя,
 * ради которых заявку и открыли.
 */
export function FieldRow({
  label,
  empty = false,
  children,
}: {
  label: string;
  /** Пустое значение приглушается: это не текст поля, а признак его отсутствия. */
  empty?: boolean;
  children: ReactNode;
}) {
  return (
    <div className={styles.fieldRow}>
      <span className={styles.fieldRowLabel}>{label}</span>
      <span className={clsx(styles.fieldRowValue, empty && styles.fieldRowEmpty)}>{children}</span>
    </div>
  );
}

/** Пара снимков рядом: колонка «было» и колонка «стало». */
export function ImagePair({
  before,
  after,
  beforeLabel,
  afterLabel,
}: {
  before: ReactNode;
  after: ReactNode;
  /* Подписи приходят СНАРУЖИ: на одном экране они одни и те же у текста и у
     снимков, а зовутся по-разному у игрока («В реестре») и у проверяющего
     («в принятой версии»). */
  beforeLabel: string;
  afterLabel: string;
}) {
  return (
    <div className={styles.imagePair}>
      {/* Кадр прижат к НИЗУ колонки: подпись в узкой колонке бывает в одну
          строку и в две, и при верхнем выравнивании два снимка вставали на
          разной высоте — сравнивать их приходилось, водя глазами вверх-вниз. */}
      <div className={styles.imagePairCol}>
        <span className={styles.imagePairLabel}>{beforeLabel}</span>
        <div className={styles.imagePairMedia}>{before}</div>
      </div>
      <div className={styles.imagePairCol}>
        <span className={clsx(styles.imagePairLabel, styles.imagePairLabelAfter)}>
          {afterLabel}
        </span>
        <div className={styles.imagePairMedia}>{after}</div>
      </div>
    </div>
  );
}
